import Service from "./Service"
import trust from "../../assets/images/ecommerce/trust.svg"
import competition from "../../assets/images/design/competition.svg"
import proffesional from "../../assets/images/design/proffesional.svg"
import logo from "../../assets/images/services/graphicdesign.svg"
import content from "../../assets/images/toCheck/content.svg"
import flyers from "../../assets/images/toCheck/flyers.svg"
import banners from "../../assets/images/toCheck/banners.svg"
import promos from "../../assets/images/toCheck/promos.svg"
import other from "../../assets/images/toCheck/other.svg"
import brain from "../../assets/images/design/brain-design-bg.svg"

const design = {
  t1: "design_title",
  header: [
    "design_header1",
    "design_header2",
    "design_header3",
  ],
  time: "design_time",
  brain: brain,
  benefits: [
    {
      img: proffesional,
      text: "design_benefits1",
    },
    {
      img: competition,
      text: "design_benefits2",
    },
    {
      img: trust,
      text: "design_benefits3",
    },
  ],
  info: "design_info",
  toCheck: [
    {
      id: "logo",
      text: "design_check1",
      img: logo,
    },
    {
      id: "content",
      text: "design_check2",
      img: content,
    },
    {
      id: "flyers",
      text: "design_check3",
      img: flyers,
    },
    {
      id: "banners",
      text: "design_check4",
      img: banners,
    },
    {
      id: "promos",
      text: "design_check5",
      img: promos,
    },
    {
      id: "another",
      text: "design_check6",
      img: other,
    },
  ],
};

const Design = () => {
    return (
        <Service service={design}/>
    )   
}

export default Design